import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DwDesignerStateService } from '@devwareapps/devware-cap';
import { QuestionFormLayoutVariant } from '../../models/question-form-layout.model';
import { QuizFormLayoutWidgetRegistrationService } from '../../services/quiz-form-layout-widget-registration.service';
import { QuestionFormLayoutWidgetComponent } from './question-form-layout-widget.component';

@Component({
  selector: 'app-quiz-form-layout-widget',
  templateUrl: './form-layout-widget.component.html',
  styleUrls: ['./form-layout-widget.component.scss']
})
export class QuizFormLayoutWidgetComponent extends QuestionFormLayoutWidgetComponent {
  readonly title = 'Quiz editor layout';
  readonly variants: QuestionFormLayoutVariant[] = [
    { key: 'redesign', label: 'Redesign', description: 'CAP cards, clear settings and consistent form controls', asset: '' },
    { key: 'original', label: 'Original', description: 'Restore the layout saved before the redesign', asset: '' }
  ];

  constructor(fb: FormBuilder, designer: DwDesignerStateService, layout: QuizFormLayoutWidgetRegistrationService) {
    super(fb, designer, layout);
  }
}
